import React, { useContext } from 'react';
import { PdfFlipbook } from '../components/pdfFlipbook/PdfFlipbook';
import { PdfMobileView } from '../components/pdfFlipbook/PdfMobileView';
import { LanguageContext } from '../contexts/Language';
import { t } from '../contexts/Language/reducer';
import useMediaQuery from '../util/hooks/useMediaQuery';
import { MEDIA_QUERY_MAX_WIDTH } from '../util/Constants';
import { PortfolioPage } from '../types/portfolio';
import portfolioPdfsData from '../data/portfolio-pdfs.json';

/**
 * Portfolio page component
 * Displays PDF portfolio with responsive switching between desktop flipbook and mobile scrollable view
 */
export const Portfolio: React.FC = () => {
  const [languageState] = useContext(LanguageContext);
  const isMobile = useMediaQuery(`(max-width: ${MEDIA_QUERY_MAX_WIDTH}px)`);

  // Load PDF URLs from manifest file
  // Edit src/data/portfolio-pdfs.json to change the order or add/remove PDFs
  // Supports both old format (string[]) and new format (PortfolioPage[])
  const pdfUrls = portfolioPdfsData as string[] | PortfolioPage[];

  return (
    <div className="w-full min-h-screen bg-gray-50 p-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-light text-center mb-8 text-gray-800" style={{ fontFamily: 'custom-font' }}>
          {t('portfolio', languageState)}
        </h1>

        {isMobile ? <PdfMobileView pdfUrls={pdfUrls} /> : <PdfFlipbook pdfUrls={pdfUrls} />}
      </div>
    </div>
  );
};
